import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=ed4fefac&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed4fefac')) {
      api.createRecord('ed4fefac', component.options)
    } else {
      api.reload('ed4fefac', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=ed4fefac&", function () {
      api.rerender('ed4fefac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-85s25qlC5ou5P/JS/offershelp.vue"
export default component.exports